import React from "react";

import { CustomerIO } from "./customerio";
import { Zendesk } from "./zendesk";

export const Messenger: React.FC<{}> = () => {
  return (
    <>
      <Zendesk key="zendesk" />
      <CustomerIO key="customerio" />
    </>
  );
};
